import OGMLink from './Link';

export default OGMLink;
